import { render, staticRenderFns } from "./tocompany.vue?vue&type=template&id=06a8ed8d&scoped=true"
import script from "./tocompany.vue?vue&type=script&lang=js"
export * from "./tocompany.vue?vue&type=script&lang=js"
import style0 from "./tocompany.vue?vue&type=style&index=0&id=06a8ed8d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06a8ed8d",
  null
  
)

export default component.exports